import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import ArrowIcon from "../../images/icons/Icon_arrow_left.svg";
import * as styles from "../../styles/modules/BoleronEuBanner.module.sass";

const BoleronEuBanner = () => {
  const { t } = useTranslation();

  return (
    <div className={styles["banner"]}>
      <div className={styles["left"]}>
        <a href="https://boleron.eu" target="_blank" rel="noreferrer">
          <span className={styles["title"]}>Boleron.eu</span>
        </a>
        <span className={styles["separator"]}>|</span>
        <span className={styles["description"]}>{t("BoleronEuDescription", "Платформа за сравнение на застрахователни продукти в Европа.")}</span>
      </div>
      <a href="https://boleron.eu" target="_blank" rel="noreferrer" className={styles["link"]}>
        {t("BoleronEuSeeMore", "Виж повече")}
        <ArrowIcon className={styles["arrowIcon"]} />
      </a>
    </div>
  );
};

export default BoleronEuBanner;
